import {
    AuthApi,
    UsersApi,
    Configuration,
    ConfigurationParameters,
    CustomersApi,
    ProductsApi,
    PriceListsApi,
    PartnersApi,
    OffersApi,
    SummaryApi,
    DiscountsApi,
    PaymentsApi,
    ReportsApi,
} from '@app/api/client';
import { unauthorizedMiddleware } from '@app/api/unauthorizedMiddleware';
import { selfish } from '@app/utils/selfish';

const params: ConfigurationParameters = {
    basePath: '',
    middleware: [unauthorizedMiddleware],
};

const configuration = new Configuration(params);

export const api = {
    auth: selfish(new AuthApi(configuration)),
    users: selfish(new UsersApi(configuration)),
    partners: selfish(new PartnersApi(configuration)),
    customers: selfish(new CustomersApi(configuration)),
    products: selfish(new ProductsApi(configuration)),
    priceLists: selfish(new PriceListsApi(configuration)),
    offers: selfish(new OffersApi(configuration)),
    summary: selfish(new SummaryApi(configuration)),
    discounts: selfish(new DiscountsApi(configuration)),
    payments: selfish(new PaymentsApi(configuration)),
    reports: selfish(new ReportsApi(configuration)),
};
